import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";

// icons 
import { FaReact, FaNodeJs } from "react-icons/fa"
import { SiReactrouter, SiChakraui, SiExpress, SiHtml5, SiCss3, SiJavascript, SiBootstrap, SiJquery, SiRedux } from "react-icons/si"
import { VscJson } from "react-icons/vsc"


// skinstore img importing 
import sImg1 from "../../Assets/Projects/skinStore/skinStore1.png"
import sImg2 from "../../Assets/Projects/skinStore/skinStore2.png"
import sImg3 from "../../Assets/Projects/skinStore/skinStore3.png"
import sImg4 from "../../Assets/Projects/skinStore/skinStore4.png"
import sImg5 from "../../Assets/Projects/skinStore/skinStore5.png"
import sImg6 from "../../Assets/Projects/skinStore/skinStore6.png"

// kimaye img importing
import kImg1 from "../../Assets/Projects/kimaye/kimaye1.png"
import kImg2 from "../../Assets/Projects/kimaye/kimaye2.png"
import kImg3 from "../../Assets/Projects/kimaye/kimaye3.png"
import kImg4 from "../../Assets/Projects/kimaye/kimaye4.png"
import kImg5 from "../../Assets/Projects/kimaye/kimaye5.png"
import kImg6 from "../../Assets/Projects/kimaye/kimaye6.png"

// rentoMojo img importing;
import rM1 from "../../Assets/Projects/rentoMojo/rentoMojo1.png"
import rM2 from "../../Assets/Projects/rentoMojo/rentoMojo2.png"
import rM3 from "../../Assets/Projects/rentoMojo/rentoMojo3.png"
import rM4 from "../../Assets/Projects/rentoMojo/rentoMojo4.png"
import rM5 from "../../Assets/Projects/rentoMojo/rentoMojo5.png"
import rM6 from "../../Assets/Projects/rentoMojo/rentoMojo6.png"

// aeropastale img importing;
import a1 from "../../Assets/Projects/areroPastel/aero1.png"
import a2 from "../../Assets/Projects/areroPastel/aero2.png"
import a3 from "../../Assets/Projects/areroPastel/aero3.png"
import a4 from "../../Assets/Projects/areroPastel/aero4.png"
import a5 from "../../Assets/Projects/areroPastel/aero5.png"
import a6 from "../../Assets/Projects/areroPastel/aero6.png"

import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();
AOS.refreshHard();



function Projects() {
  const skinStore = [sImg1, sImg2, sImg3, sImg4, sImg5, sImg6]
  const skinIcon = [<FaReact />, <SiReactrouter />, <SiChakraui />, <VscJson />, <SiExpress />, <FaNodeJs />]

  const kimaye = [kImg1, kImg2, kImg3, kImg4, kImg5, kImg6]
  const kimayeIcon = [<SiHtml5 />, <SiCss3 />, <SiJavascript />, <SiBootstrap />, <SiJquery />]

  const rento = [rM1, rM2, rM3, rM4, rM5, rM6];
  const rentoIcon = [<FaReact />, <SiReactrouter />, <SiChakraui />, <VscJson />, <SiRedux />, <SiJavascript />]

  const aero = [a1, a2, a3, a4, a5, a6];
  const aeroIcon = [<FaReact />, <SiReactrouter />, <SiChakraui />, <SiExpress />, <SiRedux />, <SiJavascript />]

  return (
    <Container fluid className="project-section" name="projects">
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col
            md={6} className="project-card">
            <ProjectCard
              crousel={skinStore}
              techStack={skinIcon}
              title="Skin-Store"
              description="The Project is a clone of SkinStore Website. Skinstore is Basically a Ecommerce Beauty Skincare Products Website. It has User Login/Signup, Shopping functionality with a cart and payment page."
              projectType="A collaborative project built by a team of 4, executed in 4 days, I built Login/Signup functionaity and Contact page."
              ghLink="https://github.com/NandlalShah955/Skin-Store-Clone"
              demoLink="https://blossom-two.vercel.app/"
            />
          </Col>
          <Col
            md={6} className="project-card">
            <ProjectCard
              crousel={rento}
              techStack={rentoIcon}
              title="RentoMojo"
              description="RentoMojo is India's leading rental platform. It provides a wide range of product on rent."
              projectType="A collaborative project built by a team of 3, executed in 5 days. I built Landing page functionaity."
              ghLink="https://github.com/Ravi-047/likeable-wrench-2860"
              demoLink="https://heroic-profiterole-6a5148.netlify.app/"
            />
          </Col>

          <Col md={6} className="project-card">
            <ProjectCard
              crousel={aero}
              techStack={aeroIcon}
              title="Aéropostale"
              description="Aéropostale, also called Aero, is an American shopping mall–based retailer of casual apparel and accessories, principally targeting young adults through its Aéropostale stores. Aéropostale maintains control over its proprietary brands by designing, sourcing, marketing, and selling all of its own merchandise."
              projectType="A collaborative project built by a team of 5, executed in 5 days, I built landing page, Navbar, and Footer"
              ghLink="https://github.com/Ravi-047/accurate-car-8224"
              demoLink="scintillating-speculoos-1ffc52.netlify.app/"
            />
          </Col>
          <Col md={6} className="project-card">
            <ProjectCard
              crousel={kimaye}
              techStack={kimayeIcon}
              title="Kimaye (fruit-app)"
              description="Kimaye is a Mumbai based fruits and vegetable shopping website. You can buy fresh fruits and vegetable from kimaye.com, if you live in Mumbai or Delhi as at present Kimaye is operational only in Mumbai and Delhi."
              projectType="A collaborative project built by a team of 6, executed in 5 days. I built Landing page functionaity."
              ghLink="https://github.com/Amit-singh-05/kimaye-Clone"
              demoLink="https://wonderful-kelpie-0cffcb.netlify.app/"
            />
          </Col>


          <h3 >More Project Comming soon</h3>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
